import Vue from 'vue';

let thisVue = new Vue()

const state = {
    listFrom: null,
    listTo: null,
    reservationsLabels: {},
    reservationsPickupLabels: {},
    reservations: [],
    filteredEvents: [],
    filteredTime: null,
    selectedReservation: null,
    selectedProductCommissions: null,
    selectedProductCommissionsProductId: null,
    loadingPeopleFinancials: false,
    newReservationSetup: null,
    newReservation: null,
    clonedReservation: null,
    invoices: null,
    eventReservations: null,

    //new reservation 29/11/2017
    isSavingReservation: false,
    reservation:{
        agent: {},
        product:{},
        event:{},
        billing:{
            promoCode: "",
            promoCodeDiscountType: null,
            promoCodeDiscountCode: null,
            discountType: 0,
            discountValue: null,
            description: "",
            details: {
                vat: "",
                businessName: "",
                address: "",
                city: "",
                country: 176
            },
            invoices: null,
            payments: [
                // {
                //     type: {
                //         id: 1,
                //         description: "Cash"
                //     },
                //     value: null,
                //     currency: "€"
                // }
            ]
        },
        attachCommission: {
           IsToOverwriteProduct: false,
           ProductValueType: 1,
           ProductValue: 0,
           IsToOverwriteProductComponent: false,
           ProductComponentValueType: 1,
           ProductComponentValue: 0,
           IsToOverwriteComponent: false,
           ComponentValueType: 1,
           ComponentValue: 0,
           IsToOverwriteTransport: false,
           TransportValueType: 1,
           TransportValue: 0
       },
        customer:{
            prefix: null,
            name: null,
            surname: null,
            phone: null,
            accomodation: null,
            room: null,
            email: null,
            country: null,
            countryDial: null,
            isInvalid: true,
        },
        helper: {
            totalToPay: null,
        },
        transport:{
            transfers:[]
        },
        notes: [
            {
                note: null,
                noteVisibilityMomentType: 1,
                type: 1
            }
        ],
        creatorAgent: null,
        creatorSupplier: null,
        creatorUserAccount: null
    },
    reservationSelectedProduct: null,
    reservationSelectedEvent: null,
    isAddingReservation: false,
    isGettingReservationById: false,
    reservationCalculations: {
        "discountDescription": null,
        "discountValueType": 0,
        "discountValue": null,
        "promocodeDescription": null,
        "promocodeValueType": 0,
        "promocodeValue": 0,
        "parcels": [],
        "totalProductGrossprice": 0,
        "totalComponentGrossprice": 0,
        "totalTransportGrossprice": 0,
        "totalProductNetprice": 0,
        "totalComponentNetprice": 0,
        "totalTransportNetprice": 0,
        "totalGrossprice": 0,
        "totalDiscounts": 0,
        "grandTotal": 0
    },
    bulkSelectedIds: [],
    isLoadingCalculations: false,
    calculationsGUID: null,
    selectedEventIdListReservations: null,

    //resechedule
    isRescheduling: false,

    //cancel tokens
    updateCheckinsNoShowsCancelToken: null,
    reservationEditCancelToken: null,

    //reservation listing | also used for bulk actions
    reservationListFilters: null,
    reservationListType: 1, // departure, pickup, sale
    reservationListAllSelected: false,
    isGettingReservationNr: false,

    //payments
    paymentsStatusList: [
        {
            label: 'Paid',
            id: 1
        },
        {
            label: 'In Due',
            id: 0
        },
        {
            label: 'Overpaid',
            id: 2
        },
    ],
};

const getters = {
    getListFrom: (state) => state.listFrom,
    getListTo: (state) => state.listTo,
    getReservationsLabels: (state) => state.reservationsLabels,
    getReservationsPickupLabels: (state) => state.reservationsPickupLabels,
    getFilteredEvents: (state) => state.filteredEvents,
    getFilteredTime: (state) => state.filteredTime,
    getSelectedReservation: (state) => {
        if(state.selectedReservation && state.selectedReservation.event.eventComponents){
            state.selectedReservation.bookingComponents.map(reservationComponent => {
                let eventComponent = state.selectedReservation.event.eventComponents.filter(r => {
                    return r.component.id == reservationComponent.component.id
                })[0]

                // only if the component / extra is still available
                if(eventComponent){
                    reservationComponent.originalQuantity = eventComponent.quantity
                    reservationComponent.quantityAvailable = eventComponent.quantityAvailable
                } else {
                    // we enter this "else" if the extra on the reservation is no longer part of the product
                    reservationComponent.componentExtinct = true

                }
            })
        }

        return state.selectedReservation
    },
    getSelectedProductCommissions: (state) => state.selectedProductCommissions,
    getIsLoadingPeopleFinancials: (state) => state.loadingPeopleFinancials,
    getClonedReservation: (state) => state.clonedReservation,
    getNewReservationSetup: (state) => state.newReservationSetup,
    getInvoices: (state) => state.invoices,
    clonedReservation: (state) => state.clonedReservation,
    getReservations: (state) => state.reservations,
    getEventReservations: (state) => state.eventReservations,
    reservation: (state) => {
        return state.selectedReservation ? state.selectedReservation : state.newReservation;
    },

    //new reservation 29/11/2017
    getIsSavingReservation: (state) => state.isSavingReservation,
    getIsAddingReservation: (state) => state.isAddingReservation,
    getReservation: (state) => state.reservation,
    getReservationSelectedProduct: (state) => state.reservationSelectedProduct,
    getReservationSelectedEvent: (state) => state.reservationSelectedEvent,
    getReservationCalculations: (state) => state.reservationCalculations,

    //reschedule
    getIsRescheduling: (state) => state.isRescheduling,

    getBulkSelectedIds: (state) => state.bulkSelectedIds,
    getIsLoadingCalculations: (state) => state.isLoadingCalculations,
    getIsGettingReservationById: (state) => state.isGettingReservationById,
    getSelectedEventListReservations: (state) => state.selectedEventIdListReservations,
    getReservationListFilters: (state) => state.reservationListFilters,
    getReservationListType: (state) => state.reservationListType,
    getIsGettingReservationNr: (state) => state.isGettingReservationNr,
    getPaymentsStatusList: (state) => state.paymentsStatusList,

}

const actions = {
    async initReservations({ commit, rootState, dispatch }) {
        try {
            // let response = await axios.get('/api/reservation/ListReservation', { params: { supplierId: rootState.user.account.supplierId }});

            if (response && response.status === 200 && response.data) {
                commit('INIT_RESERVATIONS', {
                    reservations: response.data,
                    reservationsLabels: {
                        startDate: 'Start date',
                        reservation: 'Reservation',
                        fullName: 'Name',
                        seller: 'Agent/Seller',
                        pax: 'PAX',
                        sellDate: 'Event Dates',
                        statusDescription: 'Status',
                        totalPrice: 'Total',
                        checkin: 'Check-in',
                        noshow: 'No Show',
                    },
                    pickupLabels: {
                        pickupDate: 'PickUp Date',
                        from: 'From',
                        to: 'To',
                        customer: 'Customer',
                        reservation: 'Reservation',
                        pax: 'PAX',
                        language: 'Language',
                        departure: 'Departure',
                        notes: 'Notes & Alerts',
                    },
                });

                return true;
            }

            return false;
        }
        catch (error) {
            //Vue.toasted.error(error);
        }
    },

    setEventReservations({ commit, rootState, dispatch }, eventId) {
        //let eventId = 2715;

        return axios.get('/api/reservation/ListReservation', {
            params: {
                supplierId: rootState.user.account.supplierId,
                eventId: eventId
            }
        }).then(response => {
            if (response.status == 200 && response.data) {
                commit('SET_EVENTRESERVATIONS', response.data);
            }

        })
    },


    contactReservation: ({ commit }, item) => {

    },

    rescheduleReservation: ({ commit }, item) => {

    },

    editReservation: ({ commit }, item) => {

    },

    deleteReservation: ({ commit }, item) => {

    },

    // Narrows down the list of reservations

    filterReservationsList: ({ commit }, list) => {
        commit('FILTER_RESERVATIONS_LIST', list);
    },

    // Updates date range in reservations list

    updateDateRange: ({ commit }, range) => {
        commit('UPDATE_RESERVATIONS_DATE_RANGE', range);
    },

    // Updates date range in reservations list

    searchByQuery: ({ commit }, query) => {
        commit('UPDATE_RESERVATIONS_QUERY', query);
    },

    // Resets the new reservation setup window to its default filters.
    // Waits for both the categories and events to be init'd before updating

    async resetNewReservationSetup ({ commit, dispatch, rootState }) {
        // Default from/to ranges must ensure we're not showing events from the past

        let from = moment().format('YYYY-MM-DD');
        let to = moment().add(rootState.settings.eventsRangeDays, 'days').format('YYYY-MM-DD');
        let params = { from: from, to: to }

        let categoriesResponse = await dispatch('initCategories');
        let eventsResponse = await dispatch('initEvents', params);

        if (categoriesResponse && eventsResponse) {
            dispatch('closeModal');

            commit('UPDATE_FIELDS', {
                object: 'newReservationSetup',
                fields: {
                    from: from,
                    to: to,
                    dates: null,
                    time: null,
                    event: null,
                    query: null,
                    pax: null,
                    list: rootState.inventory.events
                }
            });

            return true;
        }
    },

    // Updates the new reservation filters with the provided list of results
    // for this given filter. Afterwards, applies the filter itself to the current
    // array of results (merging previous filters)

    updateNewReservationSetup: ({ commit, state, dispatch, rootState }, fields) => {

        commit('UPDATE_FIELDS', { object: 'newReservationSetup', fields });

        var newReservationSetup = state.newReservationSetup;
        var list = rootState.inventory.events;

        for (var key in newReservationSetup) {
            var filter = newReservationSetup[key];

            // Match against all 'sub-arrays' (from and to are control date strings, so we skip them)

            if (key !== 'list' && key !== 'from' && key !== 'to' && filter && filter.length > 0) {
                list = _.intersection(list, filter);
            }
        }

        commit('INTERSECT_NEW_RESERVATION_SETUP_CHOICES', list);
    },

    // Forces the list of events to be emptied

    emptyNewReservationSetupList: ({ commit, rootState }) => {
        commit('UPDATE_FIELDS', {
            object: 'newReservationSetup',
            fields: { list: [] }
        });
    },

    // Forces the list of events to be cleared

    clearNewReservationSetupList: ({ commit, rootState }) => {
        commit('UPDATE_FIELDS', {
            object: 'newReservationSetup',
            fields: { list: rootState.company.events }
        });
    },

    // Updates a brand new reservation with the specified fields

    updateNewReservation: ({ commit, state }, fields) => {
        commit('UPDATE_FIELDS', { object: 'newReservation', fields: fields });
    },

    setSelectedReservation: ({ commit }, id) => {
        commit('SET_SELECTED_RESERVATION', id);
    },

    downloadSelectedProductCommissions: ({commit, rootState, state}, productId) => {
        // if(state.selectedProductCommissionsProductId != productId){
            state.loadingPeopleFinancials = true
            return axios.get('api/supplier/GetPeopleFinancials', {
                params:{
                    supplierId: rootState.user.account.supplierId,
                    productid: productId
                }
            }).then(response => {
                state.loadingPeopleFinancials = false
                commit('UPDATE_SELECTED_PRODUCT_COMMISSONS', response.data)
                state.selectedProductCommissionsProductId = productId
            }).catch(err => {
                state.loadingPeopleFinancials = false
            })
        // } else {
        //     return false
        // }
    },

    // Reverts current changes to the reservation to its previous state when editing

    revertReservationChanges: ({ commit }, pre) => {
        commit('REVERT_RESERVATION_CHANGES', pre);
    },

    // Clears the currently active reservation

    clearActiveReservation: ({ commit }) => {
        commit('CLEAR_ACTIVE_RESERVATION');
    },

    // Adds a new payment

    addReservationPayment: ({ commit, state, getters }, payment) => {
        commit('ADD_PAYMENT', { reservation: getters.reservation, payment: payment });
    },

    // Deletes the current payment

    deleteReservationPayment: ({ commit }, data) => {
        commit('DELETE_PAYMENT', data);
    },

    // Adds a new refund

    addReservationRefund: ({ commit }, refund) => {
        commit('ADD_REFUND', refund);
    },

    // Adds a new note. Supports adding both to the new reservation and
    // the selected reservation (create and edit mode)

    addReservationNote: ({ commit, getters }, note) => {
        commit('ADD_RESERVATION_NOTE', { reservation: getters.reservation, note: note });
    },

    addReservationPromo: ({ commit, getters }, promo) => {
        commit('UPDATE_RESERVATION_PROMO', { reservation: getters.reservation, promo: promo });
    },

    deleteReservationPromo: ({ commit, getters }) => {
        commit('UPDATE_RESERVATION_PROMO', { reservation: getters.reservation, promo: null });
    },

    // Adds an item (placebo for update method)
    // Parameters: { action: 'edit', object: 'category', table: 'categories', fields: { object } }

    addReservation: ({ dispatch }, data) => {
        dispatch('updateReservation', data);
        dispatch('closeModal');
    },

    updateReservation: ({ dispatch, rootState }, data) => {
        if (!data.action) {
            throw new Error('Invalid action on updateReservation');
        }

        const action = data.action.charAt(0).toUpperCase() + data.action.slice(1);
        let msg = 'Reservation saved successfully!';

        if (data.action === 'cancel') {
            msg = 'Reservation canceled successfully!';
        }

        axios.post('/api/reservation/Reservation' + action, data.fields).then((response) => {
            if (response && response.status === 200) {
                dispatch('initReservations');

                Vue.router.push({ name: 'reservations' });
                Vue.toasted.success(msg);

                dispatch('clearClonedReservation');
            }
        })
        .catch(function(error) {
            // Error messages are being handled directly in the transport file. We'll only
            // print an error if no message is available.

            if (!(error.response.data !== undefined && error.response.data && error.response.data.message !== undefined && error.response.data.message)) {
                //Vue.toasted.error(error);
            }
        });
    },

    rescheduleReservation: ({ dispatch, rootState }, fields) => {
        axios.post('/api/calendar/SetBookingToReschedule', fields).then((response) => {
            if (response && response.status === 200) {
                dispatch('initReservations');
                dispatch('closeModal');

                Vue.router.push({ name: 'reservations' });
                Vue.toasted.success('Reservation rescheduled successfully!');

                dispatch('clearClonedReservation');
            }
        })
        .catch(function(error) {
            //Vue.toasted.error(error);
        });
    },

    // Finishes cancelling a reservation and ties it with a description

    cancelReservation: ({ dispatch, rootState }, data) => {
        dispatch('updateReservation', data);
        dispatch('closeModal');
    },

    // Sets up the new reservation field set to its blank state.
    // Clears everything before doing so

    resetClonedReservation: ({ commit, dispatch, state }) => {
        dispatch('clearActiveReservation').then(() => {
            commit('UPDATE_CLONED_RESERVATION', {
                    salesDate: null,
                    status: null,
                    dealType: null,
                    notes: null,
                    event: null,
                    customer: null,
                    agent: null,
                    billing: {
                        promoCode: '',
                        promoCodeDiscountType: null,
                        promoCodeDiscountCode: null,
                        discountType: null,
                        discountValue: null,
                        description: '',
                        details: null,
                        invoices: null,
                        payments: null,
                    },
                    transport: null,
            });
        });
    },

    // Replaces the whole cloned reservation object with the new one.
    // We're doing this to avoid not hydrating deep nested arrays

    updateClonedReservation: ({ commit, state }, form) => {
        commit('UPDATE_CLONED_RESERVATION', form);
    },

    // Clears only cloned reservation

    clearClonedReservation: ({ commit }) => {
        commit('CLEAR_CLONED_RESERVATION');
    },

    //new reservation 29/11/2017
    //the following action have "existing" on their name, I know it's stupid but it's to avoid conflicts with older actions
    setReservation: ({ commit }, payload) => {
        commit('SET_RESERVATION', payload);
    },

    resetReservation: ({ commit }) => {
        commit('RESET_RESERVATION')
    },

    setReservationSelectedProduct: ({ commit }, payload) => {
        commit('SET_RESERVATION_SELECTED_PRODUCT', payload);
    },

    setReservationSelectedEvent: ({ commit }, payload) => {
        commit('SET_RESERVATION_SELECTED_EVENT', payload);
    },

    createNewReservation: ({ commit, dispatch, state }, payload) => {
        if(!state.isAddingReservation){


            // check booking question
            let bookingQuestionPromise = new Promise((resolve, reject) => {
                if(payload.reservation.event.bookingQuestionIsActive && payload.reservation.event.bookingQuestionIsActive == true){
                        dispatch('openModal', {
                            name: 'bookingQuestion',
                            callback: (e) => {
                                resolve(e)
                            }
                        })
                } else {
                    resolve('no_question')
                    // return {
                    //     status: 400 //fake status to prevent continuing
                    // }
                }
            })


            return bookingQuestionPromise.then(response => {
                if(response == 'ok' || response == 'no_question'){
                    console.log('bookingQuestionPromise response', response);
                    return dispatch('saveNewReservation', payload)
                }
            })

        }
    },

    saveNewReservation: ({commit, dispatch}, payload) => {
        state.isAddingReservation = true;
        return new Promise((resolve, reject) => {
            axios.post('/api/reservation/ReservationCreate', payload).then((response) => {
                state.isAddingReservation = false;
                if (response && response.status === 200) {
                    // mixpanel

                    thisVue.$ma.trackEvent({action:'Create Reservation', properties: {success:true, bookingNr: payload.reservation.sequencialNumber}})
                }
                resolve(response);
                return response
            })
            .catch(function(error) {
                state.isAddingReservation = false;
                thisVue.$ma.trackEvent({action:'Create Reservation', properties: {success:false, bookingNr: payload.reservation.sequencialNumber}})
                reject(error);
                return error
            });
        })
    },

    updateExistingReservation: ({commit, dispatch, state}, payload) => {
        if(state.reservationEditCancelToken){
            state.reservationEditCancelToken.cancel();
        }

        let source = axios.CancelToken.source();
        state.reservationEditCancelToken = source

        //if the reservation has a "changeStatusTo" we set that as the status
        if(payload.reservation.changeStatusTo){
            payload.reservation.status = payload.reservation.changeStatusTo

            // this is when reservation is changing to Canceled
            if(payload.reservation.changeStatusTo == "-5"){
                thisVue.$ma.trackEvent({
                    action:'Cancel Booking',
                    properties: {
                        'bookingId': payload.reservation.id,
                    }
                })
            }
        }

        state.isSavingReservation = true
        return axios.post('/api/reservation/ReservationEdit', payload, {
            cancelToken: source.token
        }).then((response) => {
            state.isSavingReservation = false
            state.selectedReservation.billing = JSON.parse(JSON.stringify(response.data.billing))
            if (response && response.status === 200) {
                dispatch('initReservations');

                // mixpanel
                let reservation = payload.reservation
                if(reservation.updateFlags && reservation.updateFlags.checkins){
                    thisVue.$ma.trackEvent({
                        action:'Checkin',
                        properties: {
                            'bookingId': reservation.id,
                            'checkin':reservation.paxCheckedIn,
                            'no-show':reservation.paxNoShow,
                            'paxTotal': reservation.paxTotal
                        }
                    })
                }


                //if reservation is saved while viweing a list of reservations from a specific event it redirects to that list else it redirects to the generic 'reservations'
                // console.log('DEBUG: rootState.getSelectedEventListReservations', state.state.selectedEventIdListReservations);
                if(state.selectedEventIdListReservations){
                    Vue.router.push({ name: 'reservationsEvent' });
                } else {
                    Vue.router.push({ name: 'reservations' });
                }
                Vue.toasted.success('Reservation saved');

                //if reservation is by GetYourGuide and is set to "cancel" / "pending cancelation" we will also show a message saying that the email to GYG was sent
                if(payload.reservation.channelType == 202 && payload.reservation.status == -6){
                    Vue.toasted.success('Request sent');
                }


            }
            return response
        }).catch(error => {
            state.isSavingReservation = false
        })
    },

    cancelExistingReservation: ({commit, dispatch, state}, payload) => {
        return new Promise((resolve, reject) => {
            axios.post('/api/reservation/ReservationCancel', payload).then((response) => {
                if (response && response.status === 200) {
                    dispatch('initReservations');
                    Vue.router.push({ name: 'reservations' });
                    Vue.toasted.success('Reservation canceled');

                    resolve(response);

                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    rescheduleExistingReservation: ({commit, dispatch, state}, payload) => {
        state.isRescheduling = true
        let oldReservation = payload.booking

        return axios.post('/api/calendar/SetBookingToReschedule', payload).then((response) => {
            state.isRescheduling = false
            if (response && response.status === 200) {

                thisVue.$ma.trackEvent({
                    action:'Rebook',
                    properties: {
                        'rebookFrom': oldReservation.id,
                        'rebookTo': response.data.id,
                    }
                })

                Vue.toasted.success('Reservation rescheduled successfully!');
                return response
            }
        })
        .catch(function(error) {
            state.isRescheduling = false
            return error
            //Vue.toasted.error(error);
        });

    },

    updateCheckinsNoShows: ({commit, dispatch, state}, payload) => {
        // return new Promise(function(resolve, reject) {

            if(state.updateCheckinsNoShowsCancelToken){
                state.updateCheckinsNoShowsCancelToken.cancel();
            }

            let source = axios.CancelToken.source();
            state.updateCheckinsNoShowsCancelToken = source

            return axios.post('/api/booking/DoCheckIn', payload, {
                cancelToken: source.token
            }).then((response) => {
                if (response && response.status === 200) {

                    //Vue.toasted.success('Reservation rescheduled successfully!');
                    // resolve(response)
                    return response
                }
            })
            .catch(function(error) {
                // reject(error)
                //Vue.toasted.error(error);
            });

        // });
    },

    pushReservationToStore: ({ commit }, reservation) => {
        commit('PUSH_RESERVATION', reservation)
    },

    setReservationCalculations: ({ state, commit, rootState }, reservation) => {
        state.isLoadingCalculations = true
        //if we have a calculationsGuid we set it to this reservation
        // if(state.calculationsGUID){
        //     reservation.calculationsGUID = state.calculationsGUID
        // }
        //this cancels the last request if a new one is made
        if(this.cancelEventsRequestToken){
            this.cancelEventsRequestToken.cancel('Operation canceled by the user.');
        }

        let CancelToken = axios.CancelToken;
        let source = CancelToken.source();
        this.cancelEventsRequestToken = source;

        return axios.post('api/booking/SupplierCalculatePricing', {
            supplierId: rootState.user.account.supplierId,
            reservation: reservation,
        }, {
            cancelToken: source.token
        }).then(response => {
            state.isLoadingCalculations = false
            if (response.status == 200) {
                commit('SET_RESERVATION_CALCULATIONS', response.data)

                //saves the calculationsGuid to use on future calculation request to speed them up
                state.calculationsGUID = response.data.calculationsGUID
            }
            return response
        }).catch(error => {
            // state.isLoadingCalculations = false
            return error
        })
    },

    addToBulkSelectedIds: ({state}, payload) => {

        for (let idToAdd of payload) {
            if(state.bulkSelectedIds.includes(idToAdd)){

            } else {
                state.bulkSelectedIds.push(idToAdd)
            }
        }
    },

    removeFromBulkSelectedIds: ({state}, payload) => {
        console.log('removeFromBulkSelectedIds');
        for (let idToRemove of payload) {
            if(state.bulkSelectedIds.includes(idToRemove)){
                state.bulkSelectedIds.splice(state.bulkSelectedIds.indexOf(idToRemove),1)
            } else {
            }
        }
    },

    setBulkSelectedIds: ({state}, payload) => {
        state.bulkSelectedIds = payload
    },

    resetCalculationsGuid: ({state}) => {
        state.calculationsGUID = null
    },

    openReservationById: ({state, rootState, dispatch, commit}, reservationId) => {
        state.isGettingReservationById = true
            // test if ticket exists
        return axios.get('api/reservation/FindReservationBySupplier', {
            params: {
                supplierId: rootState.user.account.supplierId,
                reservationId: reservationId
            }
        }).then((response) => {
            state.isGettingReservationById = false
            if(response !== null && response !== undefined && response.status == 200){
                if(response.data !== null){
                    //ticket exists
                    commit('PUSH_RESERVATION', response.data)
                    // this.pushReservationToStore(response.data)
                    // this.triggerModal(Number(vm.ticketNr), 'ReservationEdit');
                    commit('SET_SELECTED_RESERVATION', response.data);
                    dispatch('openModal', 'ReservationEdit')
                } else {
                    Vue.$toasted.info('Ticket #'+vm.ticketNr+' not found');
                }
                return response
            }
        }).catch((error) => {
            state.isGettingReservationById = false
            console.log(error);
            return error
        });

    },

    setSelectedEventListReservations: ({state}, event) => {
        // console.log('DEBUG setSelectedEventListReservations Accessed with: ', event);
        // this value is used when the button "reservations" on [calendar -> selected event] is pressed
        // this contains the event id to filter the results
        // this also prevents the id from being on the url
        state.selectedEventIdListReservations = event
    },

    setReservationListFilters: ({state}, payload) => {
        state.reservationListFilters = payload
    },
    setReservationListType: ({state}, payload) => {
        state.reservationListType = payload
    },
    setReservationListAllSelected: ({state}, payload) => {
        state.reservationListAllSelected = payload
    },
    getNumberForNewReservation: ({state, rootState}, payload) => {
        state.isGettingReservationNr = true
        return axios.get('api/booking/GetBookingSequencialNumber', {
            params: {
                supplierId: rootState.user.account.supplierId,
            }
        }).then(response => {
            state.isGettingReservationNr = false
            return response
        }).catch(err => {
            state.isGettingReservationNr = false
            return err
        })
    }
};

export const mutations = {
    // Deletes a given item from both the full listing and
    // the filtered listing

    DELETE_RESERVATION: (state, item) => {
        Vue.delete(state.reservations, item);
        Vue.delete(state.list, item);
    },

    INIT_RESERVATIONS: (state, data) => {
        var from = moment();
        var to = moment().add(7, 'days');

        state.reservations = data.reservations;
        state.reservationsLabels = data.reservationsLabels;
        state.reservationsPickupLabels = data.pickupLabels;
        state.invoicesLabels = {
            date: 'Date',
            description: 'Description',
            type: 'Type',
            value: 'Amount',
            status: 'Status'
        };

        // Store range as strings

        state.listFrom = from;
        state.listTo = to;
    },

    SET_EVENTRESERVATIONS: (state, data) => {
        state.eventReservations = data;
    },

    // Sets the selected reservation across the store

    SET_SELECTED_RESERVATION: (state, payload) => {
        if(typeof payload == 'object'){
            state.selectedReservation = payload
        } else {
            state.selectedReservation = (payload) ? state.reservations.find(r => r.id === payload) : null;
        }
    },

    // Filters the full reservations list

    FILTER_RESERVATIONS_LIST: (state, list) => {
        state.reservations = list;
    },

    // Filters by date range

    UPDATE_RESERVATIONS_DATE_RANGE: (state, range) => {
        if (range.from !== undefined && range.from) {
            state.listFrom = range.from;
        }

        if (range.to !== undefined && range.to) {
            state.listTo = range.to;
        }

        var from = state.listFrom;
        var to = state.listTo;
        var filtered = state.reservations;

        // Filter list by salesDate according to the chosen from/to dates

        if (from && to) {
            filtered = filtered.filter(r => {
                var salesDate = moment(r.salesDate);

                if (salesDate.diff(from) >= 0 && salesDate.diff(to) <= 0) {
                    return r;
                }
            });
        }

        state.reservations = filtered;
    },

    // Filters by query

    UPDATE_RESERVATIONS_QUERY: (state, query) => {
        state.query = query;
    },

    // This mutation will handle the merging of all setup filters
    // from across the reservation add modal. This includes the
    // text search, date ranges, people mapping, product filtering
    // and timeframe filtering. The resulting list will be an 'inner
    // join calculated between all filtering possibilities so that
    // we're always narrowing/expanding the current list

    INTERSECT_NEW_RESERVATION_SETUP_CHOICES: (state, list) => {
        state.newReservationSetup.list = list;
    },

    // Reverts an auto-saving edition back to the original reservation we had
    // before editing.

    REVERT_RESERVATION_CHANGES: (state, old) => {
        var item = state.reservations.find(r => r.id === old.id);

        if (item) {
            var i = _.indexOf(state.reservations, item);

            if (i != -1) {
                state.reservations.splice(i, 1, old);
            }
        }
    },

    // Clears the currently active reservation, be it
    // the selectedReservation or the newReservation object

    CLEAR_ACTIVE_RESERVATION: (state) => {
        state.selectedReservation = null;
        state.newReservation = null;
        state.clonedReservation = null;
    },

    // Updates a set of fields in an object

    UPDATE_FIELDS: (state, data) => {
        if (state[data.object] === undefined || !state[data.object]) {
            state[data.object] = {};
        }

        Object.keys(data.fields).forEach((key) => {
            Vue.set(state[data.object], key, data.fields[key]);
        });
    },


    //Remove action and mutation!!
    ADD_PAYMENT: (state, data) => {
        var reservation = data.reservation;

        if (reservation.billing.payments === undefined) {
            Vue.set(reservation.billing, 'payments', []);
        }

        // Copy the list of payments, operate on it, and save it from scratch
        // (Vue caveat)

        let paymentList = JSON.parse(JSON.stringify(reservation.billing.payments));

        paymentList.push(data.payment);

        Vue.set(reservation.billing, 'payments', paymentList);
    },

    //Remove action and mutation!!
    // Removes a payment method row

    DELETE_PAYMENT: (state, data) => {
        data.collection.splice(data.index, 1);
    },

    // Sets a payment description for the given reservation

    ADD_PAYMENT_DESCRIPTION: (state, data) => {
        if (state[data.object].billing === undefined) {
            Vue.set(state[data.object], 'billing', []);
        }

        Vue.set(state[data.object].billing, 'description', data.description);
    },

    // Adds a new refund entry to the active reservation

    ADD_REFUND: (state, refund) => {
        if (state.selectedReservation.billing.refunds === undefined) {
            state.selectedReservation.billing.refunds = [];
        }

        state.selectedReservation.billing.refunds.push(refund);
    },

    UPDATE_RESERVATION_PROMO: (state, data) => {
        data.reservation.billing.promo_id = data.promo;
    },

    CANCEL_RESERVATION: (state, data) => {
        var reservation = state.reservations.find(r => r.id === data.reservation.id);

        Vue.set(reservation, 'status', 'canceled');
    },

    UPDATE_CLONED_RESERVATION: (state, data) => {
        state.clonedReservation = data;
    },

    CLEAR_CLONED_RESERVATION: (state) => {
        state.clonedReservation = null;
    },

    //new reservation 29/11/2017
    SET_RESERVATION_SELECTED_PRODUCT: (state, data) => {
        state.reservation.product = data
    },

    SET_RESERVATION_SELECTED_EVENT: (state, data) => {
        state.reservation.event = data
    },

    SET_RESERVATION: (state, data) => {
        state.reservation = data
    },

    PUSH_RESERVATION: (state, reservation) => {
        state.reservations.push(reservation)
    },

    RESET_RESERVATION: (state) => {
        //resets the number of people
        if(state.reservation.event.eventGenderPrices && state.reservation.event.eventGenderPrices.length > 0){
            state.reservation.event.eventGenderPrices.map((item) => {
                item.quantityToBook = 0;
            })
        }

        //resets extras
        if(state.reservation.event.eventComponents && state.reservation.event.eventComponents.length > 0){
            state.reservation.event.eventComponents.map((item) => {
                item.quantityBooked = 0;
            })
        }

        state.reservation = {
            agent: {},
            product:state.reservation.product,
            event:state.reservation.event,
            billing:{
                promoCode: "",
                promoCodeDiscountType: null,
                promoCodeDiscountCode: null,
                discountType: 0,
                discountValue: null,
                description: "",
                details: {
                    vat: "",
                    businessName: "",
                    address: "",
                    city: "",
                    country: 176
                },
                invoices: null,
                payments: [
                    // {
                    //     type: {
                    //         id: 1,
                    //         description: "Cash"
                    //     },
                    //     value: null,
                    //     currency: "€"
                    // }
                ]
            },
            attachCommission: {
                IsToOverwriteProduct: false,
                ProductValueType: 1,
                ProductValue: null,
                IsToOverwriteProductComponent: false,
                ProductComponentValueType: 1,
                ProductComponentValue: 0,
                IsToOverwriteComponent: false,
                ComponentValueType: 1,
                ComponentValue: 0,
                IsToOverwriteTransport: false,
                TransportValueType: 1,
                TransportValue: 0
            },
            customer:{
                prefix: null,
                name: null,
                surname: null,
                phone: null,
                accomodation: null,
                room: null,
                email: null,
                country: null,
                countryDial: null,
                isInvalid: true,
            },
            helper: {
                totalToPay: null,
            },
            transport:{
                transfers:[]
            },
            notes: [
                {
                    note: null,
                    noteVisibilityMomentType: 1,
                    type: 1
                }
            ],
            creatorAgent: null,
            creatorSupplier: null,
            creatorUserAccount: null
        }
    },

    SET_RESERVATION_CALCULATIONS: (state, data) => {
        state.reservationCalculations = data
    },

    UPDATE_SELECTED_PRODUCT_COMMISSONS: (state, data) => {
        state.selectedProductCommissions = data
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reservations.js